const l = [], i = [], d = "insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).";
function c() {
  const e = document.createElement("style");
  return e.setAttribute("type", "text/css"), e;
}
function a(e, r) {
  if (r = r || {}, e === void 0)
    throw new Error(d);
  const o = r.prepend === !0 ? "prepend" : "append", s = r.container !== void 0 ? r.container : document.querySelector("head");
  let n = l.indexOf(s);
  n === -1 && (n = l.push(s) - 1, i[n] = {});
  let t;
  return i[n] !== void 0 && i[n][o] !== void 0 ? t = i[n][o] : (t = i[n][o] = c(), o === "prepend" ? s.insertBefore(t, s.childNodes[0]) : s.appendChild(t)), e.charCodeAt(0) === 65279 && (e = e.substr(1, e.length)), t.styleSheet ? t.styleSheet.cssText += e : t.textContent += e, t;
}
export {
  a as default
};
